import { render, staticRenderFns } from "./CreditScore.vue?vue&type=template&id=0f5cd5f1&"
import script from "./CreditScore.vue?vue&type=script&lang=js&"
export * from "./CreditScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports